import { RouteObject } from "react-router";
import Calibration from "./Calibration";
import CalibrationCrumb from "./CalibrationCrumb";
import { getResultSetAndTrees } from "../../../../../../../API/fields";

const routes: RouteObject = {
  id: "calibrate",
  path: "/customer/:customerId/field/:fieldId/result-set/:resultSetId/calibrate",
  loader: getResultSetAndTrees,
  Component: Calibration,
  handle: {
    Crumb: CalibrationCrumb,
  },
};

export default routes;
